import { useCurrentTeam } from '@/providers/TeamProvider';
import { Link } from 'react-router-dom';

export const TeamPhaseSkipSettingElement = () => {
  const { _w_, me, _t_, isAdmin } = useCurrentTeam();

  return (
    <div className="card mb-4">
      <div className="card-header d-flex align-items-center">
        <div className="col-md-8">
          <h5 className="mb-0">タスクスキップ設定</h5>
          <p className="text-xs mb-0">タスクフェーズを省略することができます</p>
        </div>
        <div className="col-md-4 d-flex justify-content-end">
          {isAdmin && (
            <Link
              to={`/w/${_w_!.identifier}/setting/teams/${_t_!.id}/team_phase_skip_setting/edit`}
              className="btn btn-icon-only btn-outline-success"
            >
              <i className="fas fa-edit text-success text-sm"></i>
            </Link>
          )}
        </div>
      </div>
      <div className="card-body pt-0">
        <div className="table-responsive">
          <table className="table align-items-center">
            <thead>
              <tr>
                <th
                  className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                  style={{ width: 200 }}
                >
                  タスク名
                </th>
                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">設定内容</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <h6 className="mb-0">見積申請</h6>
                </td>
                <td className="text-secondary text-xs text-wrap">
                  <SkippableBadgeElement skippable={_t_!.task_phase_skip_setting.quotation_task_skippable} />
                </td>
              </tr>
              <tr>
                <td>
                  <h6 className="mb-0">契約申請（売上）</h6>
                </td>
                <td className="text-secondary text-xs text-wrap">
                  <SkippableBadgeElement skippable={_t_!.task_phase_skip_setting.sales_order_contract_task_skippable} />
                </td>
              </tr>
              <tr>
                <td>
                  <h6 className="mb-0">請求</h6>
                </td>
                <td className="text-secondary text-xs text-wrap">
                  <SkippableBadgeElement skippable={_t_!.task_phase_skip_setting.invoice_task_skippable} />
                </td>
              </tr>
              <tr>
                <td>
                  <h6 className="mb-0">契約申請（費用）</h6>
                </td>
                <td className="text-secondary text-xs text-wrap">
                  <SkippableBadgeElement
                    skippable={_t_!.task_phase_skip_setting.purchase_order_contract_task_skippable}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <h6 className="mb-0">支払</h6>
                </td>
                <td className="text-secondary text-xs text-wrap">
                  <SkippableBadgeElement skippable={_t_!.task_phase_skip_setting.payment_task_skippable} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const SkippableBadgeElement = ({ skippable }: { skippable: boolean }) => {
  if (skippable) {
    return <span className="badge badge-danger">SKIPする</span>;
  } else {
    return <span className="badge badge-success">SKIPしない</span>;
  }
};
